/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Fable_Plan_Feat2Inputs */

const en_model_fable_plan_feat2 = /** @type {(inputs: Model_Fable_Plan_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 premium credits / month (≈10 full roadmaps on Fable)`)
};

const id_model_fable_plan_feat2 = /** @type {(inputs: Model_Fable_Plan_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 kredit premium / bulan (≈10 roadmap penuh dengan Fable)`)
};

/**
* | output |
* | --- |
* | "300 premium credits / month (≈10 full roadmaps on Fable)" |
*
* @param {Model_Fable_Plan_Feat2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_fable_plan_feat2 = /** @type {((inputs?: Model_Fable_Plan_Feat2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Fable_Plan_Feat2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_fable_plan_feat2(inputs)
	return en_model_fable_plan_feat2(inputs)
});